module.exports = __webpack_public_path__ + "img/i_event-quest_off.876bcad.png";